import * as t from "io-ts";
import * as tPromise from "io-ts-promise";
import { createCargoTemplateTypes, isoDateTime } from "dora-contracts";
import { CargoFormDataBase } from "../cargo-and-template-shared";

export const {
  editCargoTemplateInputT,
  editCargoTemplateOutputT,
  postCargoTemplateT,
} = createCargoTemplateTypes({
  decimal: t.string,
  date: t.string,
  dateTime: isoDateTime,
});

export const decodeCargoTemplate = tPromise.decode(editCargoTemplateOutputT);

export type CargoTemplateData = CargoFormDataBase & {
  id?: string; // cargo template id
  userId?: string | null; // always null here
};
